//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ToSupport from "./ToSupport";

export default {
  props: ["title", "hideTop", "hideRightIcon"],
  components: { ToSupport },
  methods: {
    handleBack() {
      if (window.history.length < 2) {
        this.$router.replace("/My");
        return;
      }
      this.$router.go(-1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/components/MyBasePage.vue